import React from "react";
import { defineMessages, useIntl } from "react-intl";

import PremiumBadge from "@/components/premium-badge";
import { HStack, Text } from "@/components/ui";
import VerificationBadge from "@/components/verification-badge";
import ActionButton from "@/features/ui/components/action-button";
import { type Account } from "@/schemas";
import { cn } from "@/utils/cn";

interface TitleProps {
  account: Account;
  showActions?: Boolean;
}

const messages = defineMessages({
  deactivated: { id: "account.deactivated", defaultMessage: "Deactivated" },
  truths: { id: "account.posts", defaultMessage: "Truths" },
});

const Title: React.FC<TitleProps> = ({ account, showActions }) => {
  const intl = useIntl();

  const deactivated = account.pleroma?.deactivated ?? false;
  const name = deactivated
    ? intl.formatMessage(messages.deactivated)
    : account.display_name;

  return (
    <HStack alignItems="center" justifyContent="between" className="w-full">
      <HStack
        alignItems="center"
        space={1}
        className="overflow-hidden md:w-[55%]"
      >
        <Text size="xl" weight="bold" tag="h1" truncate>
          {name}
        </Text>
        {account.verified && <VerificationBadge className="size-5" />}
        {account.premium && <PremiumBadge className="size-5" />}
      </HStack>

      <div
        className={cn("relative max-h-[28px] transition-all duration-200", {
          "-top-12 lg:-top-20": !showActions,
          "top-0": showActions,
        })}
      >
        <ActionButton account={account} buttonSize="sm" />
      </div>
    </HStack>
  );
};

export default Title;
